export default __webpack_public_path__ + "static/media/banner-logo.929e0319.png";